<script>
  import { Input, Label } from "sveltestrap";
  import { writable } from "svelte/store";
  import { aggregateTypes } from "../../editor/component/data.js";
  import { currentSpec, dataInfo } from "../../editor/storage.js";
  import { onDestroy, onMount } from "svelte";

  import ItemResponse from "../component/ItemResponse.svelte";
  import DomainInput from "../component/domainInput.svelte";
  import RangeInput from "../component/rangeInput.svelte";
  import SchemePicker from "../component/schemePicker.svelte";

  import {
    isNumericEncoding,
    colorSchemesMap,
    gradientString,
    encodingMap,
  } from "../../editor/component/mark.js";

  export let currEncDataType,
    currEncSort,
    currField,
    currLayer,
    currAggregate,
    currBin,
    currBinCount,
    currEncScaleType,
    currentEncoding,
    inputFocusAction,
    inputBlurAction,
    updateEncoding,
    currEncFieldType,
    currScaleScheme,
    currLayerPrev,
    rcRole;
  let maxScaleLength;

  function makeSerialInput(event, domainType, encodingType) {
    if (domain_values.length == range_values.length) {
      unmatchedScaleValues = false;
      // domain value adjustment
      if (domainType === "number")
        domain_values = domain_values.map((d) => parseFloat(d));
      // scale value ajdustment
      if (isNumericEncoding(currentEncoding))
        range_values = range_values.map((d) => parseFloat(d));
      return { domain_values, range_values };
    } else {
      unmatchedScaleValues = true;
      return undefined;
    }
  }
  let unmatchedScaleValues;

  let domain_values = [],
    range_values = [];
  function setScale(currentEncoding) {
    if (currentEncoding !== "position") {
      //for non position
      let scaleLength = Math.max(
        currLayer?.mark?.[currentEncoding]?.scale?.domain?.length ||
          currField?.scale?.domain?.length ||
          0,
        currLayer?.mark?.[currentEncoding]?.scale?.range?.length ||
          currField?.scale?.range?.length ||
          0
      );
      if (scaleLength == 0) scaleLength = 1;
      let temp = [];
      domain_values = [];
      range_values = [];
      for (let i = 0; i < scaleLength; i++) {
        // domain values
        if (
          currLayer?.mark?.[currentEncoding]?.scale?.domain?.[i] !== undefined
        )
          domain_values.push(
            currLayer?.mark?.[currentEncoding]?.scale?.domain?.[i]
          );
        else if (currField?.scale?.domain?.[i] !== undefined)
          domain_values.push(currField?.scale?.domain?.[i]);
        else domain_values.push(undefined);

        // range values
        if (currLayer?.mark?.[currentEncoding]?.scale?.range?.[i] !== undefined)
          range_values.push(
            currLayer?.mark?.[currentEncoding]?.scale?.range?.[i]
          );
        else if (currField?.scale?.range?.[i] !== undefined)
          range_values.push(currField?.scale?.range?.[i]);
        else range_values.push(undefined);
        temp.push(i);
      }
      maxScaleLength = writable(temp);
    } else {
      // for position
      let [rc, ix] = rcRole.split("/");
      let scaleLength = Math.max(
        $currentSpec.fronto?.layout?.[rc]?.[ix]?.scale?.domain?.length ||
          currField?.scale?.domain?.length ||
          0,
        $currentSpec.fronto?.layout?.[rc]?.[ix]?.scale?.range?.length ||
          currField?.scale?.range?.length ||
          0
      );
      if (scaleLength == 0) scaleLength = 1;
      let temp = [];
      domain_values = [];
      range_values = [];
      for (let i = 0; i < scaleLength; i++) {
        // domain values
        if (
          $currentSpec.fronto?.layout?.[rc]?.[ix]?.scale?.domain?.[i] !==
          undefined
        )
          domain_values.push(
            $currentSpec.fronto?.layout?.[rc]?.[ix]?.scale?.domain?.[i]
          );
        else if (currField?.scale?.domain?.[i] !== undefined)
          domain_values.push(currField?.scale?.domain?.[i]);
        else domain_values.push(undefined);

        // range values
        if (
          $currentSpec.fronto?.layout?.[rc]?.[ix]?.scale?.range?.[i] !==
          undefined
        )
          range_values.push(
            $currentSpec.fronto?.layout?.[rc]?.[ix]?.scale?.range?.[i]
          );
        else if (currField?.scale?.range?.[i] !== undefined)
          range_values.push(currField?.scale?.range?.[i]);
        else range_values.push(undefined);
        temp.push(i);
      }
      console.log(">>>>", domain_values)
      maxScaleLength = writable(temp);
    }
  }
  $: {
    setScale(currentEncoding);
  }
  let on = false;
  onMount(() => {
    on = true;
    setScale(currentEncoding);
  });
  // currentSpec.subscribe((spec) => {
  //   if (on) setScale(currentEncoding);
  // });
  onDestroy(() => {
    on = false;
    maxScaleLength.set([]);
    domain_values = [];
    range_values = [];
  });

  let schemeAfterPick, schemeValue;
  let showSchemePicker = false;
  function openSchemePicker(afterPick, value) {
    showSchemePicker = true;
    schemeAfterPick = afterPick;
    schemeValue = value;
  }
  function closeSchemePicker() {
    showSchemePicker = false;
    schemeAfterPick = undefined;
    schemeValue = undefined;
  }
  function afterScaleUpdate(event) {
    console.log(event);
    let detail = makeSerialInput(event, currEncFieldType, currentEncoding);
    console.log(detail);
    if (detail)
      updateEncoding(
        detail,
        currentEncoding,
        "encoding.scale.values",
        currLayerPrev
      );
  }
</script>

<div class="dupo-menu-pane mb-2">
  <!-- encoding type -->
  <div class="dupo-menu-pane-row">
    <Label for="encoding_type">Encoding type</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      type="select"
      class="custom-form-select"
      id="encoding_type"
      name="encoding_type"
      value={currEncDataType}
      on:change={(event) => {
        updateEncoding(event, currentEncoding, "encoding.type", currLayerPrev);
      }}
    >
      <option value={undefined}>Select</option>
      <option value="quantitative">🔢 Quantitative</option>
      <option value="ordinal">🪜 Ordinal</option>
      <option value="nominal">🏷 Nominal</option>
      <option value="temporal">📆 Temporal</option>
    </Input>
  </div>
</div>

{#if encodingMap[currentEncoding]?.sortable}
  <div class="dupo-menu-pane mb-2">
    <!-- sort -->
    <div class="dupo-menu-pane-row">
      <Label>Sort</Label>
    </div>
    <div class="dupo-menu-pane-form-row form-inline">
      <Input
        type="radio"
        name="sort"
        id="sort_ascending"
        class="pt-1"
        value="ascending"
        group={currEncSort}
        on:change={(event) => {
          updateEncoding(
            event,
            currentEncoding,
            "encoding.sort",
            currLayerPrev
          );
        }}
      />
      <Label for="sort_ascending" class="pt-1 mb-0 me-2">Ascending</Label>
      <Input
        type="radio"
        name="sort"
        id="sort_descending"
        class="pt-1"
        value="descending"
        group={currEncSort}
        on:change={(event) => {
          updateEncoding(
            event,
            currentEncoding,
            "encoding.sort",
            currLayerPrev
          );
        }}
      />
      <Label for="sort_descending" class="pt-1 mb-0 me-2">Descending</Label>
    </div>
    <div class="dupo-menu-pane-form-row form-inline">
      <Input
        type="radio"
        name="sort"
        id="sort_custom"
        class="pt-1"
        value="custom"
        group={currEncSort}
        on:change={(event) => {
          updateEncoding(
            event,
            currentEncoding,
            "encoding.sort",
            currLayerPrev
          );
        }}
      />
      <Label for="sort_custom" class="pt-1 mb-0 me-2">Custom</Label>
      <Input
        type="radio"
        name="sort"
        id="sort_none"
        class="pt-1"
        value="none"
        group={currEncSort}
        on:change={(event) => {
          updateEncoding(
            event,
            currentEncoding,
            "encoding.sort",
            currLayerPrev
          );
        }}
      />
      <Label for="sort_none" class="pt-1 mb-0 me-2">None</Label>
    </div>
  </div>
  {#if currEncSort === "custom"}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <Label for="sort_order">Custom sort</Label>
      </div>

      <div class="dupo-menu-pane-form-row">
        <Input
          type="textarea"
          name="custom_sort"
          id="custom_sort"
          class="custom-form-select text-sm"
          autocomplete="off"
          value={currLayer?.mark?.[currentEncoding]?.sort?.order?.join(",") ||
            currField?.sort?.order?.join(",") ||
            ""}
          on:focus={inputFocusAction}
          on:blur={inputBlurAction}
          on:change={(event) => {
            updateEncoding(
              event,
              currentEncoding,
              "encoding.sort.order",
              currLayerPrev
            );
          }}
        />
      </div>
      <div class="dupo-menu-pane-row">
        <p class="mb-0 text-sm pt-1">Separate values with comma</p>
      </div>
    </div>
  {/if}
{/if}

{#if encodingMap?.[currentEncoding]?.scalable}
  {#if currEncDataType === "quantitative"}
    <div class="pane-divider" />
    {#if currLayer?.mark?.[currentEncoding]?.aggregate !== "count" || currField?.aggregate !== "count"}
      <!-- aggregate -->
      <div class="dupo-menu-pane mb-2">
        <div class="dupo-menu-pane-row">
          <Label for="aggregate">Aggregate</Label>
        </div>
        <div class="dupo-menu-pane-form-row">
          <Input
            type="select"
            name="aggregate"
            id="aggregate"
            class="custom-form-select text-sm"
            bind:value={currAggregate}
            on:focus={inputFocusAction}
            on:blur={inputBlurAction}
            on:change={(event) => {
              updateEncoding(
                event,
                currentEncoding,
                "encoding.aggregate",
                currLayerPrev
              );
            }}
          >
            <option value={undefined}>Select</option>
            {#each aggregateTypes as agg}
              <option value={agg.value}>{agg.name}</option>
            {/each}
          </Input>
        </div>
      </div>
    {/if}
    <!-- bin -->
    <!-- bin true/false -->
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <Label>Bin</Label>
      </div>
      <ItemResponse
        type="inline-check"
        token="bin"
        title="Use bin"
        value={currBin}
        changeAction={(event) => {
          currBin = event.target.checked;
          updateEncoding(event, currentEncoding, "encoding.bin", currLayerPrev);
        }}
      />
      <!-- maxbins -->
      {#if currBin}
        <div class="dupo-menu-pane-row">
          <Label for="binCount">Bin count</Label>
        </div>
        <div class="dupo-menu-pane-form-row">
          <Input
            type="number"
            name="bin_count"
            id="bin_count"
            autocomplete="off"
            class="custom-form-select"
            bind:value={currBinCount}
            on:change={(event) => {
              updateEncoding(
                event,
                currentEncoding,
                "encoding.bin.nBins",
                currLayerPrev
              );
            }}
          />
        </div>
      {/if}
    </div>
  {/if}
  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <!-- scale: continuous/ordinal/nominal scales; color/number/shape/dash scales -->
    <!-- scale type: default, pre-existing,  -->
    <div class="dupo-menu-pane-row">
      <Label>Scale</Label>
    </div>
    <!-- default scale -->
    <div
      class="dupo-menu-pane-form-row form-inline"
      style="margin-bottom: -0.25rem;"
    >
      <Input
        type="radio"
        class="mb-0"
        name="scale"
        id="scale_default"
        value="default"
        group={currEncScaleType}
        on:change={(event) => {
          currEncScaleType = "default";
          updateEncoding(
            event,
            currentEncoding,
            "encoding.scale.type",
            currLayerPrev
          );
        }}
      />
      <Label for="scale_default" class="mb-0">Default</Label>
    </div>
  </div>
  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <!-- domain and range -->
    <div
      class="dupo-menu-pane-form-row form-inline"
      style="margin-bottom: -0.25rem;"
    >
      <Input
        type="radio"
        class="mb-0"
        name="scale"
        id="scale_domain_range"
        value="domain_range"
        group={currEncScaleType}
        on:change={(event) => {
          currEncScaleType = "domain_range";
          updateEncoding(
            event,
            currentEncoding,
            "encoding.scale.type",
            currLayerPrev
          );
        }}
      />
      <Label for="scale_domain_range" class="mb-0">Domain & range</Label>
    </div>
  </div>
  <!-- domain / range -->
  {#if currEncScaleType === "domain_range"}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row d-flex">
        <Label style="width: 50%;">Domain</Label>
        <Label style="width: 50%;">Range</Label>
      </div>
      {#if $maxScaleLength?.constructor.name === "Array"}
        {#each $maxScaleLength || [] as index}
          <!-- domain:number / todo: make a component per datatype -->
          <div class="dupo-menu-pane-form-row-multi">
            <DomainInput
              {index}
              {inputFocusAction}
              {inputBlurAction}
              {domain_values}
              {currEncFieldType}
              {afterScaleUpdate}
            />
            <!-- scale: number / todo: make a component per datatype -->
            <RangeInput
              {index}
              {inputFocusAction}
              {inputBlurAction}
              {range_values}
              {currentEncoding}
              {afterScaleUpdate}
            />
          </div>
        {/each}
      {/if}
      <div class="dupo-menu-pane-button-row mt-1">
        <button
          type="button"
          style="text-align: center;"
          on:click={() => {
            maxScaleLength.update((arr) => {
              arr.push(arr.length);
              return arr;
            });
          }}><i class="bi bi-plus-circle-fill me-1" /> New scale row</button
        >
        <!-- <button
          type="button"
          style="text-align: center;"
          on:click={(event) => {
            afterScaleUpdate(event);
          }}><i class="bi bi-check me-1" /> Apply</button
        > -->
      </div>
      {#if unmatchedScaleValues}
        <div class="dupo-menu-pane-row warn-msg">
          <p class="text-sm">
            The number of domain and range values must be same.
          </p>
        </div>
      {/if}
    </div>
  {/if}

  <!-- domain and scheme -->
  {#if currentEncoding === "fill" || currentEncoding === "stroke"}
    <div class="pane-divider" />
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-form-row form-inline">
        <Input
          type="radio"
          class="mb-0"
          name="scale"
          id="scale_scheme_only"
          value="scheme_only"
          group={currEncScaleType}
          on:change={(event) => {
            currEncScaleType = "scheme_only";
            updateEncoding(
              event,
              currentEncoding,
              "encoding.scale.type",
              currLayerPrev
            );
          }}
        />
        <Label for="scale_scheme_only" class="mb-0">Color scheme</Label>
      </div>
    </div>
  {/if}
  <!-- domain / range -->
  {#if currEncScaleType === "scheme_only"}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-form-row">
        <button
          type="button"
          class="custom-form-select"
          on:click={() => {
            openSchemePicker((event) => {
              updateEncoding(
                event,
                currentEncoding,
                "encoding.scale.scheme",
                currLayerPrev
              );
              closeSchemePicker();
            }, currScaleScheme);
          }}
          style={`background: ${gradientString(
            colorSchemesMap[currScaleScheme]?.swatch || ["#ffffff", "#ffffff"]
          )}`}
          ><span
            style="display: block; width: 100%; background-color: white; margin: 0.25rem 0;"
            ><i class="bi bi-palette2 me-1" />
            {currScaleScheme || "Pick a scale"}</span
          ></button
        >
      </div>
    </div>
  {/if}

  {#if showSchemePicker}
    <SchemePicker
      afterPick={schemeAfterPick}
      currentScheme={schemeValue}
      closer={closeSchemePicker}
    />
  {/if}
{/if}
